import { notification } from "antd";
import Cookies from 'js-cookie';

import { postBaseRequestConfig } from "./base-request-config";

export const authenticatedUserApi = {
  // Sends username(email) and password and tries to authenticate on the server
  loginEmailPassword(loginDetails) {
    return fetch(
      `${process.env.REACT_APP_API_URL}/users/authenticate`,
      postBaseRequestConfig(loginDetails)
    )
      .then((response) => response.json())
      .then((r) => {
        if (r.message) {
          notification.error({
            message: "Error",
            description: r.message,
          });
        } else {
          //Successful login, refresh the page
          Cookies.set('DLALastLogin', r.lastLogin ? r.lastLogin : null, { path: '' });
          window.location.reload();
        }
      });
  },
};
